export default [
  {
    path: "/cidade/:municipioId/recursos",
    name: "resource-list",
    component: () => import("./components/ClosingEntry.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cidade/:municipioId/recursos/novo",
    name: "resource-create",
    component: () => import("./components/Form.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cidade/:municipioId/recursos/:recursoId",
    name: "resource-detail",
    component: () => import("./components/Detail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cidade/:municipioId/recursos/:recursoId/editar",
    name: "resource-edit",
    component: () => import("./components/Form.vue"),
    meta: { requiresAuth: true },
  },
];

